import { render, staticRenderFns } from "./addNode.vue?vue&type=template&id=71f9a2ba&scoped=true"
import script from "./addNode.vue?vue&type=script&lang=js"
export * from "./addNode.vue?vue&type=script&lang=js"
import style0 from "./addNode.vue?vue&type=style&index=0&id=71f9a2ba&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f9a2ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71f9a2ba')) {
      api.createRecord('71f9a2ba', component.options)
    } else {
      api.reload('71f9a2ba', component.options)
    }
    module.hot.accept("./addNode.vue?vue&type=template&id=71f9a2ba&scoped=true", function () {
      api.rerender('71f9a2ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/workFlow/addNode.vue"
export default component.exports